// =============================================
// QUICK FILTER PILL BAR
// Injects a horizontal pill row above .product-list
// for client-side filtering by product type.
// Does NOT modify Shopify's native filter/sort system.
// Keywords use Hextom's reversed data-v4 values.
// Pills are dynamically rendered based on which
// categories actually have products on the page.
// =============================================

(function () {
  var BRAND_NAVY = '#233E5A';

  // Master pill order — All is always first, rest follow this sequence
  var PILL_DEFINITIONS = [
    { label: 'All',        filter: 'all'       },
    { label: "Women's",    filter: 'womens'    },
    { label: "Men's",      filter: 'mens'      },
    { label: 'Kids',       filter: 'kids'      },
    { label: 'Flip Flops', filter: 'flipflops' },
    { label: 'Sandals',    filter: 'sandals'   },
    { label: 'Sale',       filter: 'sale'      }
  ];

  function blockMatchesFilter(block, filter) {
    var dataSpan = block.querySelector('.htusb-data');
    var v4 = dataSpan ? (dataSpan.getAttribute('data-v4') || '') : '';

    switch (filter) {
      case 'womens':
        return v4.indexOf('snemoW') !== -1;

      case 'mens':
        // Must contain sneM but NOT snemoW to avoid matching Women's
        return v4.indexOf('sneM') !== -1 && v4.indexOf('snemoW') === -1;

      case 'kids':
        var links = block.querySelectorAll('a[href*="/products/"]');
        for (var i = 0; i < links.length; i++) {
          var href = links[i].getAttribute('href') || '';
          if (
            href.indexOf('toddler') !== -1 ||
            href.indexOf('kendall') !== -1 ||
            href.indexOf('carter')  !== -1
          ) {
            return true;
          }
        }
        return false;

      case 'flipflops':
        return v4.indexOf('spolF pilF') !== -1;

      case 'sandals':
        return v4.indexOf('sladnaS') !== -1;

      case 'sale':
        return !!block.querySelector('.product-price__amount--on-sale');

      default:
        return false;
    }
  }

  function detectActiveCategories(blocks) {
    var active = { all: true };

    blocks.forEach(function (block) {
      PILL_DEFINITIONS.forEach(function (pill) {
        if (pill.filter === 'all') return;
        if (!active[pill.filter] && blockMatchesFilter(block, pill.filter)) {
          active[pill.filter] = true;
        }
      });
    });

    return active;
  }

  function injectStyles() {
    var style = document.createElement('style');
    style.textContent =
      '#qf-pill-bar::-webkit-scrollbar { display: none; }' +
      '.qf-pill {' +
        'font-family: "Proxima Nova", "proxima-nova", proxima-nova, sans-serif;' +
        'font-size: 13px;' +
        'font-weight: 700;' +
        'text-transform: uppercase;' +
        'letter-spacing: 0.5px;' +
        'padding: 8px 20px;' +
        'border-radius: 20px;' +
        'border: 2px solid ' + BRAND_NAVY + ';' +
        'background: transparent;' +
        'color: ' + BRAND_NAVY + ';' +
        'cursor: pointer;' +
        'white-space: nowrap;' +
        'flex-shrink: 0;' +
        'line-height: 1;' +
        'transition: background 0.15s, color 0.15s;' +
      '}' +
      '.qf-pill.qf-pill--active {' +
        'background: ' + BRAND_NAVY + ';' +
        'color: #ffffff;' +
      '}' +
      '@media (max-width: 768px) {' +
        '#qf-pill-bar { padding-left: 16px; padding-right: 16px; }' +
      '}';
    document.head.appendChild(style);
  }

  function buildBar(activePills) {
    var bar = document.createElement('div');
    bar.id = 'qf-pill-bar';
    bar.setAttribute('role', 'group');
    bar.setAttribute('aria-label', 'Quick filters');
    bar.style.cssText =
      'display:flex;' +
      'flex-wrap:nowrap;' +
      'overflow-x:auto;' +
      'gap:8px;' +
      'padding:16px 0;' +
      'width:100%;' +
      '-webkit-overflow-scrolling:touch;' +
      'scrollbar-width:none;' +
      '-ms-overflow-style:none;';

    activePills.forEach(function (p) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'qf-pill' + (p.filter === 'all' ? ' qf-pill--active' : '');
      btn.textContent = p.label;
      btn.dataset.qfFilter = p.filter;
      btn.addEventListener('click', function () {
        bar.querySelectorAll('.qf-pill').forEach(function (el) {
          el.classList.remove('qf-pill--active');
        });
        btn.classList.add('qf-pill--active');
        applyFilter(p.filter);
      });
      bar.appendChild(btn);
    });

    return bar;
  }

  function applyFilter(filter) {
    var blocks = document.querySelectorAll('.product-block');

    blocks.forEach(function (block) {
      if (filter === 'all') {
        block.style.display = '';
        return;
      }
      block.style.display = blockMatchesFilter(block, filter) ? '' : 'none';
    });
  }

  function init() {
    var productList = document.querySelector('.product-list');
    if (!productList) return;
    if (document.getElementById('qf-pill-bar')) return;

    var blocks = document.querySelectorAll('.product-block');

    // If only one category would show (or none), a pill bar adds no value
    var activeCategories = detectActiveCategories(blocks);
    var activePills = PILL_DEFINITIONS.filter(function (p) {
      return activeCategories[p.filter];
    });

    // Don't render the bar if all we'd show is the 'All' pill
    if (activePills.length <= 1) return;

    injectStyles();
    var bar = buildBar(activePills);
    productList.parentNode.insertBefore(bar, productList);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

